import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { RouteData, RouteDataContext } from '@icilalune/types';
import { Project } from '@nx-icilalune/data/icilalune/types';

export const ROUTED_ID = new InjectionToken<Project>('ROUTED_ID');

export const ROUTE_NEWS_ID = new InjectionToken<Observable<string>>(
  'ROUTE_NEWS_ID'
);

export const ROUTE_BLOG_ID = new InjectionToken<Observable<string>>(
  'ROUTE_BLOG_ID'
);

export const ROUTER_URL = new InjectionToken<Observable<string>>('ROUTER_URL');

export const ROUTE_IS_HOME = new InjectionToken<Observable<boolean>>(
  'ROUTE_IS_HOME'
);

export const ROUTE_IS_SETTINGS = new InjectionToken<Observable<boolean>>(
  'ROUTE_IS_SETTINGS'
);

export const ROUTE_HOME_NODE_ID = new InjectionToken<Observable<string>>(
  'ROUTE_HOME_NODE_ID'
);

export const ROUTE_ELEVATOR_FRAGMENT = new InjectionToken<Observable<string>>(
  'ROUTE_ELEVATOR_FRAGMENT'
);

export const ROUTE_CLIENT_ID = new InjectionToken<Observable<string>>(
  'ROUTE_CLIENT_ID'
);

export const ROUTE_SERVICE_ID = new InjectionToken<Observable<string>>(
  'ROUTE_SERVICE_ID'
);

export const ROUTE_PAGE_ID = new InjectionToken<Observable<string>>(
  'ROUTE_PAGE_ID'
);

export const ROUTE_PROJECT_ID = new InjectionToken<Observable<string>>(
  'ROUTE_PROJECT_ID'
);

export const ROUTE_SOLUTION_ID = new InjectionToken<Observable<string>>(
  'ROUTE_SOLUTION_ID'
);

export const ROUTE_CONTEXT = new InjectionToken<Observable<RouteDataContext>>(
  'ROUTE_CONTEXT'
);

export const ROUTE_DATA = new InjectionToken<Observable<RouteData>>(
  'ROUTE_DATA'
);

export const ROUTE_LANGUAGE = new InjectionToken<Observable<string>>(
  'ROUTE_LANGUAGE'
);
